import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlMessages from './ControlMessages.js';
import { getCandidateMessages } from '../../../Api/ExtranetActions.js'

declare var globalSns;
declare var $;

class ExtranetCandidatesMessages extends Component {
    constructor(props) {
        super(props);

        this.state = {}
        
        this.reload = this.reload.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getCandidateMessages(this.props.id, globalSns.languageId, (data) => {
            this.setState({
                candidateMessages: data
            });
        });
    }

    reload() {
        this.loadData();
    }

    render() {
        if (this.state.candidateMessages == null) {
            return (
                <Loading/>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlMessages messages={this.state.candidateMessages}
                        candidateId={this.props.id}
                        candidateName={this.props.title}
                        onNavigateToProjects={(row) => this.props.onNavigate("extranetProjectsFiche", row.projectId, row.project)}
                        onReload={this.reload} />
                </div>
            </div>
        );
    }
}

export default ExtranetCandidatesMessages;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetCandidatesMessages.js